import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  getDataDiff(startDate: any, endDate: any) {
    startDate = new Date(startDate);
    endDate = new Date(endDate);

    let diff = endDate.getTime() - startDate.getTime();
    let years = Math.floor(diff / (365.25 * 24 * 60 * 60 * 1000))
    let months = Math.floor(diff / (30.44 * 24 * 60 * 60 * 1000));
    let days = Math.floor(diff / (60 * 60 * 24 * 1000));
    let hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    let minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    let seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));

    if (years > 0) {
      return this.formatArabicDuration(years, 'سنة', 'سنتين', 'سنوات');
    }

    if (months > 0) {
      return this.formatArabicDuration(months, 'شهر', 'شهرين', 'أشهر');
    }

    if (days > 0) {
      return this.formatArabicDuration(days, 'يوم', 'يومين', 'أيام');
    }

    if (hours > 0) {
      return this.formatArabicDuration(hours, 'ساعة', 'ساعتين', 'ساعات');
    }

    if (minutes > 0) {
      return this.formatArabicDuration(minutes, 'دقيقة', 'دقيقتين', 'دقائق');
    }

    if (seconds) {
      return this.formatArabicDuration(seconds, 'ثانية', 'ثانيتين', 'ثوانٍ');
    }

    return new DatePipe('en-US','Asia/Riyadh').transform(startDate);
  }

  private formatArabicDuration(count: number, singular: string, dual: string, plural: string): string {
    if (count === 1) {
      return `منذ ${singular}`;
    }
    if (count === 2) {
      return `منذ ${dual}`;
    }
    return `منذ ${count} ${plural}`;
  }
}
